export default __webpack_public_path__ + "static/media/cash.a1af4144.png";